module.exports = __webpack_public_path__ + "img/very_satisfied.2d80fc1.svg";